<h2 mat-dialog-title>Delete</h2>
<mat-dialog-content>{{confirmMessage}}</mat-dialog-content>
<mat-dialog-actions class="pull-right">
  <button mat-button mat-dialog-close class="btn btn-danger">No</button>
  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  <button mat-button class="btn btn-success" [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>